import React, { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // sessionStorage se borra automáticamente al cerrar la pestaña/navegador
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success && data.token) {
        const userData = {
          id: data.user.id,
          email: data.user.email,
          role: data.user.role.toUpperCase(),
        };

        setUser(userData);
        sessionStorage.setItem("user", JSON.stringify(userData));
        sessionStorage.setItem("token", data.token);

        return { success: true };
      } else {
        return {
          success: false,
          error: data.error || "Credenciales incorrectas",
        };
      }
    } catch (error) {
      console.error("Error en login:", error);
      return { success: false, error: "Error de conexión con el servidor" };
    }
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("token");
  };

  const isAdmin = () => {
    return user?.role === "ADMIN";
  };

  // Helper para obtener el token desde cualquier componente
  const getToken = () => sessionStorage.getItem("token");

  const value = {
    user,
    login,
    logout,
    isAdmin,
    loading,
    getToken,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth debe ser usado dentro de un AuthProvider");
  }
  return context;
};